import PullToRefresh from 'react-simple-pull-to-refresh';
import NewsRow from '../NewsRow';
import AutoSizer from 'react-virtualized-auto-sizer';
import { Box, CircularProgress, Typography, Skeleton } from '@mui/material';
import { empty } from '../../../Gift/assets/index';
import { variants } from '../../../../variants/variants';
const RowVirtualizerDynamic = ({
  rows,
  handleCardClick,
  handleDeleteClick,
  handleEditClick,
  handleLikesClick,
  children,
  virtualizer,
  parentRef,
  showLoader,
  showDefault,
  showLoading,
  showEnd,
  handleMediaLoad,
  handleRefresh,
}) => {
  const [story, ...items] = virtualizer.getVirtualItems();
  // console.log(story, items);
  return (
    <div style={{ height: '100%' }}>
      <AutoSizer disableWidth>
        {({ height }) => (
          <div
            ref={parentRef}
            className="List"
            style={{
              height: height,
              width: 400,
              overflowY: 'auto',
              contain: 'strict',
              border: '0px solid black',
              willChange: 'transform',
            }}
          >
            <div
              style={{
                height: virtualizer.getTotalSize(),
                width: '100%',
                position: 'relative',
              }}
            >
              {children}
              <div
                style={{
                  position: 'absolute',
                  top: 70,
                  left: 0,
                  width: '100%',
                  transform: `translateY(${items[0]?.start ?? 0}px)`,
                }}
              >
                <PullToRefresh
                  onRefresh={() =>
                    new Promise((resolve, reject) => {
                      setTimeout(() => {
                        handleRefresh();
                        resolve(true);
                      }, 500);
                    })
                  }
                >
                  {items.map((virtualRow, ind) => (
                    <div key={virtualRow.key} data-index={virtualRow.index} ref={virtualizer.measureElement}>
                      {showLoader ? (
                        <>
                          {[1, 2, 3].map((item) => (
                            <Box key={item} sx={{ py: 2, borderBottom: '1px solid #f0f0f0' }}>
                              <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box sx={{ flex: 1 }}>
                                  <Skeleton variant="text" width="80%" height={16} />
                                  <Skeleton variant="text" width="60%" height={16} />
                                </Box>
                              </Box>
                              <Skeleton variant="text" width="100%" height={16} />
                              <Skeleton variant="text" width="100%" height={16} />
                              <Skeleton variant="text" width="60%" height={16} />
                              <Skeleton variant="rectangle" width="90vw" height="90vw" sx={{ margin: '24px auto' }} />
                            </Box>
                          ))}
                        </>
                      ) : showDefault ? (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            width: '100%',
                            height: '30vh',
                            alignItems: 'center',
                          }}
                        >
                          <img style={{ width: '50%' }} src={empty} alt="pending" />
                          <Typography sx={{ fontSize: variants.TINY, p: 2, color: 'rgba(0,0,0,0.7)' }}>
                            No news found.
                          </Typography>
                        </Box>
                      ) : (
                        <div style={{ border: 'none' }}>
                          <NewsRow
                            key={rows[virtualRow.index]?._id}
                            news={rows[virtualRow.index]}
                            handleCardClick={() => handleCardClick(rows[virtualRow.index]?._id)}
                            handleDeleteClick={(event) => handleDeleteClick(event, rows[virtualRow.index]?._id)}
                            handleLikesClick={(event) =>
                              handleLikesClick(event, rows[virtualRow.index]?.likes, rows[virtualRow.index]?._id)
                            }
                            handleEditClick={(event) => handleEditClick(event, rows[virtualRow.index])}
                            onMediaLoad={() => handleMediaLoad(virtualRow.index)}
                          />
                          {virtualRow.index === rows.length - 1 ? (
                            <>
                              {showLoading ? (
                                <Box sx={{ py: 2, borderBottom: '1px solid #f0f0f0' }}>
                                  <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Box sx={{ flex: 1 }}>
                                      <Skeleton variant="text" width="80%" height={16} />
                                      <Skeleton variant="text" width="60%" height={16} />
                                    </Box>
                                  </Box>
                                  <Skeleton variant="text" width="100%" height={16} />
                                  <Skeleton variant="text" width="100%" height={16} />
                                  <Skeleton variant="text" width="60%" height={16} />
                                  <Skeleton
                                    variant="rectangle"
                                    width="90vw"
                                    height="90vw"
                                    sx={{ margin: '24px auto' }}
                                  />
                                </Box>
                              ) : null}
                              {showEnd ? (
                                <Box sx={{ textAlign: 'center', padding: '20px' }}>
                                  <Typography variant="body2">You've reached the end</Typography>
                                </Box>
                              ) : null}{' '}
                            </>
                          ) : null}
                        </div>
                      )}
                    </div>
                  ))}
                </PullToRefresh>
              </div>
            </div>
          </div>
        )}
      </AutoSizer>
    </div>
  );
};
export default RowVirtualizerDynamic;
